module.exports = __webpack_public_path__ + "static/media/user-chart.09de9a02.svg";